import { render, staticRenderFns } from "./addPlan.vue?vue&type=template&id=13183871&scoped=true&"
import script from "./addPlan.vue?vue&type=script&lang=js&"
export * from "./addPlan.vue?vue&type=script&lang=js&"
import style0 from "./addPlan.vue?vue&type=style&index=0&id=13183871&prod&scoped=true&lang=scss&"
import style1 from "./addPlan.vue?vue&type=style&index=1&id=13183871&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13183871",
  null
  
)

export default component.exports